import { render, staticRenderFns } from "./lottery.vue?vue&type=template&id=24c3f893&scoped=true"
import script from "./lottery.vue?vue&type=script&lang=js"
export * from "./lottery.vue?vue&type=script&lang=js"
import style0 from "./lottery.vue?vue&type=style&index=0&id=24c3f893&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "24c3f893",
  null
  
)

export default component.exports